import React, { useEffect, useState } from "react";
import { Star, Trash2, Eye, EyeOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, mediaUrl } from "@/lib/api";

export default function ReviewsAdmin({ onChange }) {
  const [list, setList] = useState(null);
  const load = () => api.get("/admin/reviews").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (r) => { await api.patch(`/admin/reviews/${r.id}`, { approved: !r.approved }); load(); onChange(); toast.success(r.approved ? "Comentario oculto" : "Comentario publicado"); };
  const remove = async (r) => { await api.delete(`/admin/reviews/${r.id}`); load(); onChange(); toast.success("Comentario eliminado"); };

  if (!list) return <Loader2 className="w-6 h-6 animate-spin brand-text" />;
  return (
    <div className="space-y-4" data-testid="admin-reviews">
      <p className="text-sm text-gray-500">{list.length} comentarios · Los comentarios nuevos se publican automáticamente. Puedes ocultarlos o eliminarlos.</p>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 divide-y divide-gray-100">
        {list.length === 0 && <p className="p-8 text-center text-gray-500 text-sm">Sin comentarios</p>}
        {list.map((r) => (
          <div key={r.id} className={`p-4 flex gap-4 items-start ${!r.approved ? "opacity-60" : ""}`} data-testid="admin-review-item">
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-semibold text-sm">{r.name}</span>
                <span className="flex">{Array.from({ length: 5 }).map((_, i) => <Star key={i} className={`w-3.5 h-3.5 ${i < r.rating ? "fill-amber-500 text-amber-500" : "text-gray-300"}`} />)}</span>
                <span className="text-xs text-gray-400">{r.date}</span>
                {r.tour_title && <span className="text-xs brand-text">· {r.tour_title}</span>}
                {!r.approved && <span className="text-xs bg-gray-100 px-2 py-0.5 rounded-full">Oculto</span>}
              </div>
              <p className="text-sm text-gray-700 mt-1 break-words">{r.text}</p>
              {r.photos?.length > 0 && <div className="flex gap-2 mt-2">{r.photos.map((ph, k) => <a key={k} href={mediaUrl(ph)} target="_blank" rel="noreferrer"><img src={mediaUrl(ph)} alt="" className="w-16 h-16 object-cover rounded-md border" /></a>)}</div>}
            </div>
            <button onClick={() => toggle(r)} className="p-2 rounded hover:bg-gray-100" title={r.approved ? "Ocultar" : "Publicar"} data-testid="review-toggle-btn">{r.approved ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}</button>
            <button onClick={() => remove(r)} className="p-2 rounded hover:bg-red-50 text-red-500" title="Eliminar" data-testid="review-delete-btn"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
